/*
	Módulo de acessibilidade básico
	- Detecta modalidade de interação (teclado / mouse / touch)
	- Adiciona classes no <body>: `focus-modality--keyboard`, `focus-modality--mouse`, `focus-modality--touch`
	- Marca elementos focados via teclado com `a11y-focus-visible`
	- Exposto como `window.AderbalA11y` com API simples para testes/manutenção
*/
(function (window, document) {
  'use strict';

  var SELECTOR_FOCUSABLE =
    'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  var state = {
    lastInput: null, // 'keyboard' | 'mouse' | 'touch'
  };

  function setModality(mod) {
    state.lastInput = mod;
    document.body.classList.toggle('focus-modality--keyboard', mod === 'keyboard');
    document.body.classList.toggle('focus-modality--mouse', mod === 'mouse');
    document.body.classList.toggle('focus-modality--touch', mod === 'touch');
  }

  function onKeyDown(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      setModality('keyboard');
    }
  }

  function onMouseDown() {
    setModality('mouse');
  }

  function onTouchStart() {
    setModality('touch');
  }

  function isInteractive(el) {
    try {
      return el && el.matches && el.matches(SELECTOR_FOCUSABLE);
    } catch (err) {
      return false;
    }
  }

  function onFocusIn(e) {
    var el = e.target;
    if (!isInteractive(el)) return;

    // Se o foco veio por teclado, marca o elemento para estilos visíveis
    if (state.lastInput === 'keyboard') {
      el.classList.add('a11y-focus-visible');
    }
  }

  function onFocusOut(e) {
    var el = e.target;
    if (!isInteractive(el)) return;
    el.classList.remove('a11y-focus-visible');
  }

  function init() {
    // Listeners de detecção de modalidade
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('mousedown', onMouseDown, true);
    document.addEventListener('touchstart', onTouchStart, true);

    // Listeners de foco para aplicar classes
    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('focusout', onFocusOut, true);
  }

  var API = {
    init: init,
    getModality: function () {
      return state.lastInput;
    },
    setKeyboard: function () {
      setModality('keyboard');
    },
    setMouse: function () {
      setModality('mouse');
    },
    setTouch: function () {
      setModality('touch');
    },
  };

  // Auto-init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expor para debugging/integração
  window.AderbalA11y = API;
})(window, document);
